import { Search } from "lucide-react";
import { cn } from "@shadcn/lib/utils";
import { Input } from "@shadcn/ui/input";

type SearchBarProps = {
	value: string;
	onChange: (value: string) => void;
};

export function SearchBar({
	value,
	onChange,
}: SearchBarProps) {
	return (
		<div className={cn("self-stretch px-6 flex flex-col items-center gap-1")}>
			<div className="relative self-stretch">
				<Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
				<Input
					name="search"
					value={value}
					onChange={(e) => {
						onChange(e.target.value);
					}}
					placeholder="Search for product or store"
					className="h-9 rounded-lg pl-9 pr-3 shadow-sm bg-background text-sm placeholder:text-muted-foreground focus-visible:ring-0 focus-visible:ring-offset-0"
				/>
			</div>
		</div>
	);
}
